import { render, staticRenderFns } from "./researchCreater.vue?vue&type=template&id=221f92d8&scoped=true"
import script from "./researchCreater.vue?vue&type=script&lang=js"
export * from "./researchCreater.vue?vue&type=script&lang=js"
import style0 from "./researchCreater.vue?vue&type=style&index=0&id=221f92d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221f92d8",
  null
  
)

export default component.exports